export const stateIncremement = (state: number) => state + 1;
